import React from 'react';

// ──────────────────────────────────────────────────────────────────────
// Vector portrait of Molly — the PR Manager NPC.
// Female counterpart to the Restorer (Jeff). Same illustrative
// language so the team panel reads as one cast: warm skin gradient,
// dark outline, subtle shading. Key character traits: short bob with
// gold barrette, light skin, lashes, soft pink lipstick, navy
// blouse, gold pearl-style earrings. Sits as a "shoulder portrait"
// so the lower half fills the circle naturally.
// ──────────────────────────────────────────────────────────────────────
const MollyPortrait = ({ size = 26 }) => (
  <svg
    viewBox="0 0 64 64"
    width={size}
    height={size}
    aria-hidden
    style={{ filter: 'drop-shadow(0 1px 1.5px rgba(0,0,0,0.45))' }}
  >
    <defs>
      <radialGradient id="mp-skin" cx="50%" cy="42%" r="55%">
        <stop offset="0%" stopColor="#FDE2C8" />
        <stop offset="100%" stopColor="#E2B891" />
      </radialGradient>
      <linearGradient id="mp-blouse" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#4A5F95" />
        <stop offset="100%" stopColor="#27355C" />
      </linearGradient>
      <linearGradient id="mp-hair" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#6B3A22" />
        <stop offset="100%" stopColor="#3D1F11" />
      </linearGradient>
      <linearGradient id="mp-gold" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#F5D07A" />
        <stop offset="100%" stopColor="#B8862A" />
      </linearGradient>
    </defs>

    {/* Blouse / shoulders */}
    <path d="M 8 64 C 8 48, 22 42, 32 42 C 42 42, 56 48, 56 64 Z" fill="url(#mp-blouse)" />
    {/* Collar V */}
    <path d="M 26 44 L 32 50 L 38 44" stroke="#1B2742" strokeWidth="1" fill="none" strokeLinecap="round" />
    {/* Small gold pendant */}
    <circle cx="32" cy="50.5" r="1.2" fill="url(#mp-gold)" stroke="#7A5A1A" strokeWidth="0.3" />

    {/* Neck */}
    <path d="M 28 42 L 28 47 L 36 47 L 36 42 Z" fill="#D9A57E" />

    {/* Hair back (frames the face from behind, full bleed under chin) */}
    <path
      d="M 16 30 C 14 18, 22 10, 32 10 C 42 10, 50 18, 48 30 L 48 42 L 16 42 Z"
      fill="url(#mp-hair)"
    />

    {/* Face */}
    <ellipse cx="32" cy="32" rx="10.5" ry="12.5" fill="url(#mp-skin)" />

    {/* Cheeks */}
    <ellipse cx="25.5" cy="35.5" rx="2.4" ry="1.6" fill="#F2A8A0" opacity="0.55" />
    <ellipse cx="38.5" cy="35.5" rx="2.4" ry="1.6" fill="#F2A8A0" opacity="0.55" />

    {/* Lashes (above eyes, gives feminine cue at small sizes) */}
    <path d="M 25.5 28.4 Q 27.2 27.4 29 28.4" stroke="#1A1A26" strokeWidth="0.9" fill="none" strokeLinecap="round" />
    <path d="M 35 28.4 Q 36.8 27.4 38.5 28.4" stroke="#1A1A26" strokeWidth="0.9" fill="none" strokeLinecap="round" />
    {/* Eyes */}
    <ellipse cx="27.2" cy="30" rx="1.05" ry="1.35" fill="#1B1B26" />
    <ellipse cx="36.8" cy="30" rx="1.05" ry="1.35" fill="#1B1B26" />
    {/* Eye highlights */}
    <circle cx="27.5" cy="29.5" r="0.4" fill="#FFFFFF" opacity="0.9" />
    <circle cx="37.1" cy="29.5" r="0.4" fill="#FFFFFF" opacity="0.9" />

    {/* Eyebrows (slim arches) */}
    <path d="M 24.5 26.6 Q 27.2 25.8 30 26.6" stroke="#3D2A1A" strokeWidth="1" fill="none" strokeLinecap="round" />
    <path d="M 34 26.6 Q 36.8 25.8 39.5 26.6" stroke="#3D2A1A" strokeWidth="1" fill="none" strokeLinecap="round" />

    {/* Lips — soft pink, slight smile */}
    <path d="M 28 39 Q 32 37.5 36 39 Q 35 40.8 32 40.8 Q 29 40.8 28 39 Z" fill="#C25A6D" />
    <path d="M 28.4 39 Q 32 39.7 35.6 39" stroke="#8A2E40" strokeWidth="0.4" fill="none" opacity="0.6" />

    {/* Hair front: side-swept fringe over forehead */}
    <path
      d="M 19 22 C 22 14, 30 11, 36 12 C 42 13, 47 18, 47 23 C 45 21, 41 19, 37 19 C 33 19, 30 20, 27 22.5 C 24 21, 21 21, 19 22 Z"
      fill="url(#mp-hair)"
    />
    {/* Gold barrette on the right side */}
    <rect x="38" y="18.5" width="6" height="2" rx="0.6" fill="url(#mp-gold)" stroke="#7A5A1A" strokeWidth="0.3" />
    <rect x="39" y="19" width="4" height="0.6" fill="#FFEEC2" opacity="0.7" />

    {/* Earrings — small gold studs */}
    <circle cx="20.5" cy="34.5" r="1.05" fill="url(#mp-gold)" stroke="#7A5A1A" strokeWidth="0.3" />
    <circle cx="43.5" cy="34.5" r="1.05" fill="url(#mp-gold)" stroke="#7A5A1A" strokeWidth="0.3" />
  </svg>
);

export default MollyPortrait;
